"use strict";
var Observable_1 = require('../../Observable');
var toPromise_1 = require('../../operator/toPromise');
Observable_1.Observable.prototype.toPromise = toPromise_1.toPromise;
//# sourceMappingURL=toPromise.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/toPromise.js
 ** module id = 328
 ** module chunks = 2
 **/